import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ReportBtnTab from './ReportBtnTab';
import ReportTabProp, { REPORT_TAB_TYPE } from '../propTypes/reportTabProp';
import ConfigsContext from '../../../contextProviders/ConfigsContext';

function ReportTabBtns(props) {
  const { t, tabActive } = props;
  const { organization, tenant } = useContext(ConfigsContext);

  const { tailorMadeAdminReports = [] } = organization || {};
  const hasNeofinReport = tailorMadeAdminReports.find(
    tailor => tailor === 'neofin_team_report',
  );

  return (
    <div className="reportTabContainer">
      {hasNeofinReport ? (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.NEOFIN_TEAM_REPORT}
          label={t('myReports.teamReport')}
          link="/reports"
        />
      ) : null}
      {organization?.services?.scorm?.enabled && (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.SCORM}
          label={t('team.report.scorm.tab')}
          link="/reports/academy/scorm"
        />
      )}

      {organization?.services?.perform?.enabled && (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.PERFORM}
          label={t('team.report.perform.tab')}
          link="/reports/perform"
        />
      )}

      {organization?.services?.journey?.enabled && (
        <ReportBtnTab
          isActive={tabActive === REPORT_TAB_TYPE.JOURNEY}
          label={t('journey')}
          link="/reports/journey"
        />
      )}
    </div>
  );
}

ReportTabBtns.propTypes = {
  t: PropTypes.func.isRequired,
  tabActive: PropTypes.oneOf(ReportTabProp.REPORT_TAB_TYPES).isRequired,
};

export default translate(ReportTabBtns);
